<template>
  <div>
    <div v-if="error">
      <server-error :error="error" />
    </div>
    <div v-if="discountRateNotificationsIds.length > 0">
      <div
        class="b-server-error mb-4 b-server-error_type_duplicate"
      >
        <div class="b-server-error__icon-wrap b-server-error__icon-wrap_type_duplicate p-4">
          <dynamic-icon icon="warning" />
        </div>
        <div class="b-server-error__inner-wrap">
          <div class="b-server-error__text-wrap px-4">
          <span>
            {{ $t('CONTENT.reportPage.no_discounting_directory_entries_months_indicated_below') }}. &nbsp;
          </span>
            <button
              class="b-import__template-btn"
              @click="contractsForRecalculationDownloadExcel"
            >
              {{ $t('CONTENT.importData.import_contract_title') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="nonActiveContractIds.length > 0">
      <div
        class="b-server-error mb-4 b-server-error_type_duplicate"
      >
        <div class="b-server-error__icon-wrap b-server-error__icon-wrap_type_duplicate p-4">
          <dynamic-icon icon="warning" />
        </div>
        <div class="b-server-error__inner-wrap">
          <div class="b-server-error__text-wrap px-4">
          <span>
            {{ $t('CONTENT.reportPage.warning') }}. &nbsp;
          </span>
            <button
              class="b-import__template-btn"
              @click="contractsHasNonActiveStatusDownloadExcel"
            >
              {{ $t('CONTENT.importData.import_contract_title') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="pt-4 pb-4 px-6 b-section__title">
        <h1>{{$t('CONTENT.reportPage.reports')}}</h1>
      </div>
      <div class="b-reports__filter p-6 mb-6">
        <ReportFilter :reportTypes="reportTypes"
                      @onSetReportsParams="setReports"
                      @downloadExcelReport="downloadExcelReport"></ReportFilter>
      </div>
      <div v-if="isShowContractInfo">
        <div class="b-reports__header px-6 mb-4">
          <div v-if="currentContract !== null">
            <ReportHeader :currentContract="currentContract" :reportTypeName="reportTypeName"></ReportHeader>
          </div>
          <div v-else-if="filterWithoutContract !== null">
            <ReportHeaderFilterWithoutContract
              :filterWithoutContract="filterWithoutContract"
              :reportTypeName="reportTypeName"
            ></ReportHeaderFilterWithoutContract>
          </div>
          <div v-else-if="chosenContracts && chosenContracts.length >= 1">
            <h2 class="mb-4">{{reportTypeName}}</h2>
            <div class="b-reports__name">{{$tc('CONTENT.contract.contract', 2)}}</div>
            <Spoiler :list="chosenContracts"></Spoiler>
          </div>
          <div v-else>
            <h2 class="mb-4">{{reportTypeName}}</h2>
          </div>
        </div>
        <div class="mb-10" v-if="currentReportType === 1">
          <ReportBasedOnExpensesWidget :dataForReport="dataForReport"></ReportBasedOnExpensesWidget>
        </div>
        <div class="mb-10" v-if="currentReportType === 2">
          <DecryptionReportBasedOnAssets :dataForReport="dataForReport"></DecryptionReportBasedOnAssets>
        </div>
        <div class="mb-10" v-if="currentReportType === 3">
          <DecryptionReportBasedOnExpenses :dataForReport="dataForReport"></DecryptionReportBasedOnExpenses>
        </div>
        <div class="mb-10" v-if="currentReportType === 4">
          <SummaryReportForContractsWithSimplification :dataForReport="dataForReport"></SummaryReportForContractsWithSimplification>
        </div>
        <div class="mb-10" v-if="currentReportType === 5">
          <SummaryReportBasedOnLiabilities :dataForReport="dataForReport"></SummaryReportBasedOnLiabilities>
        </div>
        <div class="mb-10" v-if="currentReportType === 6">
          <SummaryReportBasedOnCashOutflows :dataForReport="dataForReport"></SummaryReportBasedOnCashOutflows>
        </div>
        <div class="mb-10" v-if="currentReportType === 7">
          <SummaryReportBasedOnLiabilitiesMaturity :dataForReport="dataForReport"></SummaryReportBasedOnLiabilitiesMaturity>
        </div>
        <div class="mb-10" v-if="currentReportType === 8">
          <SummaryReportFuturePaymentsForReports :dataForReport="dataForReport"></SummaryReportFuturePaymentsForReports>
        </div>
        <div class="mb-10" v-if="currentReportType === 9">
          <DecryptionReportBasedOnAssetsAndExpenses :dataForReport="dataForReport"
                                                    :fill-discount-rate-notification-ids="fillDiscountRateNotificationIds"></DecryptionReportBasedOnAssetsAndExpenses>
        </div>
        <div class="mb-10" v-if="currentReportType === 10">
          <ReportQuarterlyAccrualCurrentLiabilities :dataForReport="dataForReport"></ReportQuarterlyAccrualCurrentLiabilities>
        </div>
      </div>
      <div v-if="errors" data-cy="server-error">
        <div v-for="(er, index) in errors" :key="index" class="b-server-error mt-4 mx-6">
          <div class="b-server-error__icon-wrap p-4">
            <dynamic-icon icon="warning"></dynamic-icon>
          </div>
          <div class="b-server-error__text-wrap px-4"><span v-html="buildReportErrorMessage(er, true)"></span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spoiler from "../components/shared/Spoiler";
import ReportsAPI from "../plugins/reports/api/ReportsAPI";
import buildReportErrorMessage from "../mixins/buildReportErrorMessage";
import NotificationList from "@/components/shared/NotificationList.vue";
import downloadFileMixin from "@/mixins/downloadFile";

export default {

  components: {
    NotificationList,
    Spoiler,
  },
  data() {
    return {
      error: null,
      errors: null,
      discountRateNotifications: null,
      params: {},
      reportTypeName: null,
      currentContract: null,
      chosenContracts: [],
      filterWithoutContract: null,
      currentReportType: null,
      isShowContractInfo: false,
      dataForReport: null,
      nonActiveContractIds: [],
      discountRateNotificationsIds: [],
    };
  },
  async created() {
    try {
      this.error = null;
      await Promise.all([
        this.$store.dispatch("getAllCounterparties"),
        this.$store.dispatch('loadContractSettings'),
        this.$store.dispatch("loadAllAssets"),
        this.$store.dispatch("loadAllUnderlyingAssetTypes"),
      ]);
    } catch (e) {
      this.error = e;
    }
  },
  computed: {
    contractIds() {
      return this.fillDiscountRateNotificationIds(this.discountRateNotifications, this.fromHeaders);
    },
    reportTypes() {
      return [
        // {
        //   displayName: this.$t ("CONTENT.reportPage.report_based_on_expenses"),
        //   id: 1,
        // },
        // {
        //   displayName: this.$t ("CONTENT.reportPage.asset_rights_report_extension"),
        //   id: 2,
        // },
        // {
        //   displayName: this.$t ("CONTENT.reportPage.decryption_report_based_on_expenses"),
        //   id: 3,
        // },
        {
          displayName: this.$t ("CONTENT.reportPage.summary_report_for_contracts_with_simplification"),
          id: 4,
        },
        // {
        //   displayName: this.$t ("CONTENT.reportPage.summary_report_based_on_liabilities"),
        //   id: 5,
        // },
        {
          displayName: this.$t ("CONTENT.reportPage.summary_report_based_on_cash_out_flows"),
          id: 6,
        },
        {
          displayName: this.$t ("CONTENT.reportPage.analysis_of_maturities_of_lease_obligations"),
          id: 7,
        },
        {
          displayName: this.$t ("CONTENT.reportPage.future_payments_for_reports"),
          id: 8,
        },
        {
          displayName: this.$t ("CONTENT.reportPage.decryption_report_based_on_assets_and_expenses"),
          id: 9,
        },
        {
          displayName: this.$t ("CONTENT.reportPage.report_quarterly_accrual_current_liabilities"),
          id: 10,
        },
        {
          displayName: this.$t ("CONTENT.reportPage.report_of_movement_guarantee_payments"),
          id: 11,
        },
      ]
    }
  },
  mixins: [buildReportErrorMessage, downloadFileMixin],
  methods: {
    async contractsForRecalculationDownloadExcel() {
      this.contractsWithoutDiscountRate = this.discountRateNotificationsIds;
      const originalType = this.importType;
      this.importType = 'contractsWithoutDiscountRate';
      await this.downloadTemplate();
      this.importType = originalType;
    },
    async contractsHasNonActiveStatusDownloadExcel() {
      this.contractsHasNonActiveStatus = this.nonActiveContractIds;
      const originalType = this.importType;
      this.importType = 'contractsHasNonActiveStatus';
      await this.downloadTemplate();
      this.importType = originalType;
    },
    fillDiscountRateNotificationIds(discountRateNotifications, fromHeaders) {
      console.log('test')
      const extractContractIds = notification => (fromHeaders ? (notification.ContractIds || []) : (notification.contractIds || []));
      this.discountRateNotificationsIds = discountRateNotifications.flatMap(extractContractIds);
      console.log(this.discountRateNotificationsIds)
    },
    async setReports(params) {
      this.chosenContracts = [];
      this.filterWithoutContract = null;
      this.params = null;
      this.currentContract = null;
      this.errors = null;

      this.params = params.formData;

      // select contract number, if -1 - that's all
      let contractNumber = null;
      if (this.params.contractNumber > 0)
        contractNumber = this.params.contractNumber;

      if(contractNumber !== null && params.lessee != null) {
        this.currentContract = await this.$store.dispatch('getContractAggregateById', contractNumber);
      }

      for (let i = 0; i < this.reportTypes.length; i++) {
        if(this.reportTypes[i].id === this.params.reportType) {
          this.reportTypeName = this.reportTypes[i].displayName;
        }
      }
      this.currentReportType = this.params.reportType;

      if(this.currentReportType === 4 ||
        this.currentReportType === 5 ||
        this.currentReportType === 6 ||
        this.currentReportType === 7 ||
        this.currentReportType === 8 ||
        this.currentReportType === 10)
      {
        this.filterWithoutContract = this.params;
      }

      this.isShowContractInfo = true;

      this.dataForReport = {
        periodStart: this.params.periodStartDate,
        periodEnd: this.params.periodEndDate,
        takeEventsBeforeDate: this.params.takeEventsBeforeDate,
        contractId: contractNumber,
        lesseeId: this.params.lessee,
        lessorId: this.params.lessor
      };
    },
    async downloadExcelReport(params) {
      // select contract number, if -1 - that's all
      let contractNumber = null;
      if (params.formData.contractNumber > 0) {
        contractNumber = params.formData.contractNumber;
      }
      const data = {
        periodStart: params.formData.periodStartDate,
        periodEnd: params.formData.periodEndDate,
        takeEventsBeforeDate: params.formData.takeEventsBeforeDate,
        contractId: contractNumber,
        lesseeId: params.formData.lessee,
        lessorId: params.formData.lessor,
        withFullAdditionalInfo: params.formData.withFullAdditionalInfo
      };

      this.error = null;
      this.errors = null;

      try {
        this.$fileLoadingManager.startLoading()
        const api = new ReportsAPI();
        let response = null;

        if (params.formData.reportType === 1) {
          response = await api.downloadResultOfReportBasedOnExpenses(data);
        }
        if (params.formData.reportType === 2) {
          response = await api.downloadResultOfDecryptionReportBasedOnAssets(data);
        }
        if (params.formData.reportType === 3) {
          response = await api.downloadResultOfDecryptionReportBasedOnExpenses(data);
        }
        if (params.formData.reportType === 4) {
          response = await api.downloadResultOfSummaryReportForContractsWithSimplification(data);
        }
        if (params.formData.reportType === 5) {
          response = await api.downloadResultOfSummaryReportBasedOnLiabilities(data);
        }
        if (params.formData.reportType === 6) {
          response = await api.downloadResultOfSummaryReportBasedOnCashOutflows(data);
        }
        if (params.formData.reportType === 7) {
          response = await api.downloadResultOfSummaryReportBasedOnLiabilitiesMaturity(data);
        }
        if (params.formData.reportType === 8) {
          response = await api.downloadResultOfSummaryFuturePaymentsForReports(data);
        }
        if (params.formData.reportType === 9) {
          response = await api.downloadResultOfDecryptionReportBasedOnAssetsAndExpenses(data);
        }
        if (params.formData.reportType === 10) {
          response = await api.downloadResultOfReportQuarterlyAccrualCurrentLiabilities(data);
        }
        if (params.formData.reportType === 11) {
          response = await api.downloadResultOfReportOfMovementGuaranteePayments(data);
        }

        let filename = null;
        let filenameInURI = null;

        let errorsJson = response.headers['report-errors'];

        if (errorsJson) {
          this.errors =  JSON.parse(decodeURI(errorsJson));
        }
        let notificationErrorsJson = response.headers['report-discountratenotifications'];
        if (notificationErrorsJson) {
          this.discountRateNotifications =  JSON.parse(decodeURI(notificationErrorsJson));
        }
        notificationErrorsJson = response.headers['report-nonactivecontractids'];
        if (notificationErrorsJson) {
          this.nonActiveContractIds =  JSON.parse(decodeURI(notificationErrorsJson));
        }
        let headerContentDisposition = response.headers['content-disposition'].split(';');
        for (let i = 0; i < headerContentDisposition.length; i++) {
          let item = headerContentDisposition[i].split('=');
          if(item[0].trim() === 'filename*') {
            filenameInURI = item[1].split("''");
            filename = decodeURIComponent(filenameInURI[1]);
          }
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        this.error = e;
        console.error(e);
      }
      this.$fileLoadingManager.finishLoading()
    }
  }
};
</script>
